import styles from "./EmptyState.module.css";

export default function EmptyState({ title, message }) {
  return (
    <div className={styles.empty}>
      <span className={styles.mark} aria-hidden="true">
        ◍
      </span>
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  );
}
